import React, { Component } from 'react';
import SignatureCanvas from "react-signature-canvas";

class SignatureStep extends Component {
  constructor(props) {
    super(props);

    this.state = {
      signatureData: null,
      signerName: '',
      error: null
    };

    this.sigCanvas = React.createRef();
    this.handleComplete = this.handleComplete.bind(this);
  }

  clearSignature = () => {
    if (this.sigCanvas.current) {
      this.sigCanvas.current.clear();
      this.setState({ signatureData: null });
    }
  };

  handleSignerNameChange = (event) => {
    this.setState({ signerName: event.target.value });
  };

  handleComplete() {
    // Validate signature
    if (!this.sigCanvas.current || this.sigCanvas.current.isEmpty()) {
      this.setState({ error: 'Please provide a signature' });
      return;
    }

    // Validate signer name
    if (!this.state.signerName.trim()) {
      this.setState({ error: 'Please enter customer name' });
      return;
    }

    const signatureData = this.sigCanvas.current.toDataURL();

    console.log("✅ Signature captured");

    // Notify parent
    this.props.onSignatureComplete(signatureData, this.state.signerName);
  }

  render() {
    const { checkin } = this.props;
    const priceChanged = checkin?.estimate_at_creation !== checkin?.estimate_at_checkin;

    return (
      <div className="signature-step">
        <h4 className="text-center mb-4">Step 3: Customer Signature</h4>

        {/* Error Display */}
        {this.state.error && (
          <div className="alert alert-danger" role="alert">
            <i className="fa fa-exclamation-triangle mr-2"></i>
            {this.state.error}
          </div>
        )}

        {/* Price Summary */}
        <div className="row justify-content-center mb-4">
          <div className="col-md-6">
            <div className="card">
              <div className="card-header bg-primary text-white">
                <h5 className="mb-0">Total Amount</h5>
              </div>
              <div className="card-body">
                {priceChanged ? (
                  <>
                    <div className="d-flex justify-content-between mb-2">
                      <span>Original Estimate:</span>
                      <span className="text-muted">
                        <s>${(checkin.estimate_at_creation || 0).toFixed(2)}</s>
                      </span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <strong>Updated Price:</strong>
                      <strong className="text-primary">
                        ${(checkin.estimate_at_checkin || 0).toFixed(2)}
                      </strong>
                    </div>
                    <hr />
                    <div className="d-flex justify-content-between">
                      <span>Difference:</span>
                      <span className={
                        checkin.estimate_at_checkin > checkin.estimate_at_creation 
                          ? 'text-danger' 
                          : 'text-success'
                      }>
                        {checkin.estimate_at_checkin > checkin.estimate_at_creation ? '+' : ''}
                        ${(checkin.estimate_at_checkin - checkin.estimate_at_creation).toFixed(2)}
                      </span>
                    </div>
                  </>
                ) : (
                  <div className="text-center">
                    <h3 className="mb-0">${(checkin.estimate_at_checkin || 0).toFixed(2)}</h3>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Agreement Text */}
        <div className="row justify-content-center mb-4">
          <div className="col-md-8">
            <div className="alert alert-info">
              <p className="mb-0">
                <strong>Customer Agreement:</strong> I authorize the work described above 
                for ${(checkin.estimate_at_checkin || 0).toFixed(2)} and acknowledge that 
                the work will be performed by a certified specialist.
              </p>
            </div>
          </div>
        </div>

        {/* Signature Canvas */}
        <div className="row justify-content-center mb-4">
          <div className="col-md-8">
            <label className="font-weight-bold mb-2">Customer Signature *</label>
            <div className="border rounded p-2 bg-light">
              <SignatureCanvas
                ref={this.sigCanvas}
                penColor="black"
                backgroundColor="rgba(255, 255, 255, 1)"
                canvasProps={{
                  width: 600,
                  height: 200,
                  className: "border rounded bg-white w-100",
                }}
                onEnd={() => {
                  const signatureData = this.sigCanvas.current.toDataURL();
                  this.setState({ signatureData, error: null });
                }}
              />
            </div>
            <div className="text-center mt-2">
              <button 
                className="btn btn-outline-secondary btn-sm"
                onClick={this.clearSignature}
              >
                <i className="fa fa-eraser mr-1"></i>
                Clear Signature
              </button>
            </div>
          </div>
        </div>

        {/* Customer Name */}
        <div className="row justify-content-center mb-4">
          <div className="col-md-8">
            <div className="form-group">
              <label htmlFor="signer-name" className="font-weight-bold">
                Customer Name *
              </label>
              <input
                id="signer-name"
                type="text"
                className="form-control"
                value={this.state.signerName}
                onChange={this.handleSignerNameChange}
                placeholder="Enter customer full name"
                disabled={this.props.loading}
              />
            </div>
          </div>
        </div>

        {/* Complete Button */}
        <div className="row">
          <div className="col-12 text-center">
            <button
              className="btn btn-success btn-lg"
              onClick={this.handleComplete}
              disabled={
                !this.state.signatureData || 
                !this.state.signerName.trim() || 
                this.props.loading
              }
            >
              {this.props.loading && (
                <span className="mr-2">
                  <i className="fa fa-refresh fa-spin" />
                </span>
              )}
              CONTINUE TO WORK VERIFICATION
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default SignatureStep;
